/** Single source of truth for app version (UI + package.json should match). */
export const APP_VERSION = '4.203.0';
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
